import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import CTASection from "../sections/CTASection";
import { PRODUCTIONS } from "../data/content";

export default function Productions() {
  useSEO({
    title: "Productions",
    description:
      "Explore Ideal Entertainment's productions — She Came Back, Le Musk, 99 Songs, Galaxy Built on Hope and One Heart.",
  });
  return (
    <>
      <PageHero
        overline="Our Work"
        title="Productions that move the world"
        subtitle="Original films, immersive cinema, documentaries and concert films."
        image="https://customer-assets-0z36b82j.emergentagent.net/job_determined-darwin-6/artifacts/okn3e94d_dw4zzx9e_WhatsApp%20Image%202026-08-24%20at%208.11.48%20AM%20%283%29.webp"
      />

      <section className="section-y">
        <div className="container-x space-y-24">
          {PRODUCTIONS.map((p, i) => (
            <Reveal key={p.title}>
              <article
                data-testid={`production-detail-${i}`}
                className={`grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center ${
                  i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="relative overflow-hidden rounded-3xl border border-white/5">
                  <img src={p.image} alt={p.title} className="aspect-[4/3] w-full object-cover" />
                  <span className="absolute left-5 top-5 rounded-full border border-white/20 bg-black/50 px-3 py-1 text-[0.65rem] uppercase tracking-[0.2em] text-gold backdrop-blur">
                    {p.tag}
                  </span>
                </div>
                <div>
                  <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-neutral-500">
                    <span>{p.year}</span>
                    <span className="h-1 w-1 rounded-full bg-gold" />
                    <span>{p.category}</span>
                  </div>
                  <h2 className="mt-4 font-playfair text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                    {p.title}
                  </h2>
                  <p className="mt-6 text-base font-light leading-relaxed text-neutral-400">
                    {p.desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
}
